import React from 'react';
import '../less/index.less';
import abank_icon from '../img/abank_icon.svg';
import minfin_img from '../img/minfin_img.svg';
import { downloadA24 } from '../../../services/urls/urls';

export default function template() {
    return (
        <div className="module-download-app-top">
          <div className="module-download-app-top__body">
            <div className="module-download-app-top__image">
              <img src={abank_icon} alt="abank icon image" />
            </div>
            <div className="module-download-app-top__right">
              <div className="module-download-app-top__title">{this.l10n('DOWNLOAD_APP_TOP_TITLE')}</div>
              <div className="module-download-app-top__text">
                <span>{this.l10n('DOWNLOAD_APP_TOP_TEXT')}</span>
                <img src={minfin_img} alt="minfin image" />
              </div>
              <a target="_blank" rel="noopener" href={downloadA24} className="module-download-app-top__btn">{this.l10n('DOWNLOAD_APP_TOP_BTN')}</a>
            </div>
          </div>
        </div>
    );
}
